const solid = 'solid';
const verySmallDots = 'very-small-dots';
const smallDots = 'small-dots';
const largeDots = 'large-dots';
const alternateDots = 'alternate-dots';
const hugeDots = 'huge-dots';
const hugeAlternateDots = 'huge-alternate-dots';
const hugeAlternateTwiceDots = 'huge-alternate-twice-dots';

export const lineStyles = [solid, verySmallDots, smallDots, largeDots, alternateDots, hugeDots, hugeAlternateDots, hugeAlternateTwiceDots];